import { SpAlert } from '../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($state, DropboxProvisioningService) {
        this.$state = $state;
        this.DropboxProvisioningService = DropboxProvisioningService;
    }

    $onInit() {
        this.groupMapping = this.resolve.groupMapping;
        this.isFullSyncEnabled = this.groupMapping.isFullSyncEnabled;
    };

    save() {
        const companyId = this.$state.params.companyId;
        const appId = this.$state.params.appId;
        const params = {companyId, appId};
        const data = {...this.groupMapping, isFullSyncEnabled: this.isFullSyncEnabled};
        this.DropboxProvisioningService.mappingSettings
            .update(params, data).$promise
            .then(() => this.close({$value: data}))
            .catch((error) => this.spAlert = new SpAlert('danger', error.data.message));
    }

    canSave() {
        return this.isFullSyncEnabled !== this.groupMapping.isFullSyncEnabled;
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-sync-settings/dropbox-sync-settings.controller.js